import { StyleSheet } from 'react-native';
import { Colors } from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    width: 250,
    backgroundColor: '#fff',
    borderRightWidth: 1,
    borderRightColor: '#e0e0e0',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    zIndex: 100,
  },
  scrollContent: {
    flex: 1,
  },
  logoContainer: {
    alignItems: 'center',
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  logo: {
    width: 160,
    height: 38,
    resizeMode: 'contain',
  },
  navSection: {
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  navItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 20,
  },
  navItemActive: {
    backgroundColor: '#FFF0F0',
    borderLeftWidth: 3,
    borderLeftColor: Colors.RedPallete.red,
    paddingLeft: 17,
  },
  navIconContainer: {
    width: 28,
    height: 28,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  navIcon: {
    width: 22,
    height: 22,
    resizeMode: 'contain',
  },
  navLabel: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.grayOne,
  },
  navLabelActive: {
    color: Colors.RedPallete.red,
    fontFamily: 'TCCC-UnityText Bold',
  },
  badge: {
    backgroundColor: Colors.RedPallete.red,
    borderRadius: 10,
    minWidth: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
    marginLeft: 8,
  },
  badgeText: {
    color: '#fff',
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    fontWeight: 'bold',
  },
  menuSection: {
    paddingVertical: 8,
  },
  menuItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  menuIconContainer: {
    width: 28,
    height: 28,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  menuIcon: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
  },
  menuLabel: {
    fontSize: 13,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.grayOne,
    flex: 1,
  },
  clientSection: {
    borderTopWidth: 1,
    borderTopColor: '#f0f0f0',
    paddingHorizontal: 20,
    paddingVertical: 12,
  },
  clientName: {
    fontSize: 13,
    fontFamily: 'TCCC-UnityText Bold',
    color: Colors.GrayPallete.grayOne,
    marginBottom: 4,
  },
  clientInfo: {
    fontSize: 11,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.RedPallete.red,
  },
  clientInfoValue: {
    color: Colors.GrayPallete.lightgrayThree,
  },
  logoutButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderTopWidth: 1,
    borderTopColor: '#f0f0f0',
    marginBottom: 20,
  },
  logoutText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightGrayFour,
    marginLeft: 12,
  },
  secondarySection: {
    borderTopWidth: 1,
    borderTopColor: '#f0f0f0',
    paddingVertical: 4,
  },
  secondaryLabel: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightGrayFour,
  },
});
